var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnityWarningCircleOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "warning_circle_outline") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 19.25c-0.809 0.011-1.462 0.67-1.462 1.481 0 0.818 0.663 1.481 1.481 1.481s1.481-0.663 1.481-1.481c0-0.409-0.166-0.779-0.434-1.047v0c-0.263-0.268-0.629-0.434-1.034-0.434-0.011 0-0.023 0-0.034 0l0.002-0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.006 9.75h-0.013c-0.972 0-1.76 0.788-1.76 1.76 0 0.077 0.005 0.153 0.014 0.227l-0.001-0.009 0.753 6.022h2l0.753-6.022c0.009-0.066 0.014-0.141 0.014-0.218 0-0.972-0.788-1.76-1.76-1.76v0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 4c-6.627 0-12 5.373-12 12s5.373 12 12 12c6.627 0 12-5.373 12-12v0c0-6.627-5.373-12-12-12v0zM16 26c-5.523 0-10-4.477-10-10s4.477-10 10-10c5.523 0 10 4.477 10 10v0c-0.006 5.52-4.48 9.994-9.999 10h-0.001z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnityWarningCircleOutline);
export default __webpack_public_path__ + "static/media/unity_warning_circle_outline.595f3f14e936effed0b37e6dfd1c8c4d.svg";
export { ForwardRef as ReactComponent };